/* eslint-disable no-shadow */
import axios from 'axios';

const api = process.env.VUE_APP_API;

const state = {
  clients: [],
  answers: [],
};

const getters = {};

const mutations = {
  SET_CLIENTS(state, data) {
    state.clients = data;
  },
  SET_ANSWERS(state, data) {
    state.answers = data;
  },
};

const actions = {
  async get(context) {
    try {
      const results = await axios.get(`${api}/client`);
      context.commit('SET_CLIENTS', results.data);
    } catch (error) {
      console.error('Error while getting clients: ', error);
    }
  },
  async create(context, data) {
    try {
      return await axios.post(`${api}/client`, data);
    } catch (error) {
      console.error('Error while creating client: ', error);
    }
    return null;
  },
  async edit(context, data) {
    try {
      return await axios.put(`${api}/client/${data.id}`, data);
    } catch (error) {
      console.error('Error while editing client: ', error);
    }
    return null;
  },
  async delete(context, data) {
    try {
      return await axios.delete(`${api}/client/${data.id}`);
    } catch (error) {
      console.error('Error while deleting client: ', error);
    }
    return null;
  },
  async answer(context, clientId) {
    try {
      const results = await axios.get(`${api}/answer/${clientId}`);
      context.commit('SET_ANSWERS', results.data);
    } catch (error) {
      console.error('Error while deleting client: ', error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
